import { useTranslation } from 'react-i18next';
import { Form } from '@anytag/shared-atoms';
import { TextSearchField, SingleMonthPickerField, SingleMonthPickerFieldProps } from '@anytag/shared-molecules';
import { YoutubeCMSFilterFormKeys } from './schemaTypes';

export interface TemplateProps extends Pick<SingleMonthPickerFieldProps, 'disabledMonths'> {
  onSubmit?: () => void;
  searchPlaceholder?: string;
}

export const Template = ({ onSubmit, searchPlaceholder, disabledMonths }: TemplateProps) => {
  const { t } = useTranslation();

  return (
    <Form.Fields>
      <TextSearchField<YoutubeCMSFilterFormKeys>
        name="keyword"
        onSubmit={onSubmit}
        placeholder={searchPlaceholder || t<string>('Search.YoutubeCMSChannels')}
      />
      <SingleMonthPickerField<YoutubeCMSFilterFormKeys>
        name="month"
        clearable={false}
        onSubmit={onSubmit}
        css={{ maxWidth: '184px' }}
        disabledMonths={disabledMonths}
      />
    </Form.Fields>
  );
};
